import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getGroups(queryString) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/groupsAPI/data?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching groups data"
                    });
                }
            });
    },
    getNonDeletedHierarchies() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/hierarchies/all-group-hierarchies", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching group hierarchies"
                    });
                }
            });
    }, getGroupInfo(api) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + api, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching groups data"
                    });
                }
            });
    }, saveGroup(dto) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/usersgroups/groupsAPI/saveGroup", dto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }, disableGroup(id, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/usersgroups/groupsAPI/" + id + "/disableGroup", { "disableReason": deletedReason }).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }, enableGroup(id) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/usersgroups/groupsAPI/" + id + "/enableGroup").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }
}